import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})

export class ProfileImageService {

	private _cachedAvatars: Record<string, string | null> = {};

    private _hasImage: Record<string, boolean> = {}

    constructor() {}

	GetCacheValue(ID: string, url: string) {
        if (this._cachedAvatars[ID] === null || this._cachedAvatars[ID] === undefined) {
            this._cachedAvatars[ID] = `${this.DeterminePrefixString(url)}ticks=${new Date().getTime()}`;
        }
        return url+this._cachedAvatars[ID];
	}

	RemoveCacheValue(ID: string) {
        this._cachedAvatars[ID] = null;
	}

	private DeterminePrefixString(url: string): string {
        if (url && !url.match(/[\?]/)) {
            return '?';
        }
        return '&';
	}

    SetValueForHasImage(ID: string, hasImage: boolean) {
        this._hasImage[ID] = hasImage;
    }

    GetHasImage(ID: string | undefined): boolean {
        return ID ? this._hasImage[ID] : false;
    }
}
